import React, { useState, useContext } from "react";
import AllProducts from "./AllProducts";
import CategoryProducts from "./CategoryProducts";
import { AllProductContext } from "../../context/AllProductProvider";

function Products({ categoryId, searched }) {
  const { allProduct } = useContext(AllProductContext);

  return (
    <>
      {allProduct && <AllProducts searched={searched} />}
      {!allProduct && <CategoryProducts categoryId={categoryId} />}
    </>
  );
}

export default React.memo(Products);
